import { lazy, Suspense } from 'react'

import { LoadingSpinner } from 'components/shared/LoadingSpinner'

import type { ComparisonBulkScreen } from 'modules/comparison-bulk/screens/ComparisonBulkScreen'

const Library = lazy(() =>
  import(/* webpackChunkName: "comparison-bulk" */ 'modules/comparison-bulk/screens/ComparisonBulkScreen').then(
    (module: { ComparisonBulkScreen: typeof ComparisonBulkScreen }) => ({ default: module.ComparisonBulkScreen })
  )
)

export const ComparisonBulkPage = () => {
  /* --- Section 6: Render --- */
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Library />
    </Suspense>
  )
}
